import cartRowTemplate from '../partials/cart-row.html';

export function CartRow() {
    return {
        template: cartRowTemplate,
    };
}
